import React from 'react';
import { VisuallyHidden as ReachVisuallyHidden, VisuallyHiddenProps} from '@reach/visually-hidden';

const VisuallyHidden = ({children, ...props}: VisuallyHiddenProps) => (
  <ReachVisuallyHidden {...props}>{children}</ReachVisuallyHidden>
);

export default VisuallyHidden;
